import { API } from 'core';
import { ServerRoute } from 'core/api';

export interface LearnerMatchingMetricsResponse {
  providerID: string;
  providerName: string;
  totalCMEMatchedCount: number;
  totalMOCMatchedCount: number;
  totalSubmissionCount: number;
  totalSubmissionCountMOC: number;
  earliestReportDate: string;
  latestReportDate: string;
}

export interface LearnerMatchingMetricsQuery {
  startDate: Date;
  endDate: Date;
  providerId?: string;
}

export class LearnerMatchingMetricsService {
  public static async getAggregated(params: LearnerMatchingMetricsQuery): Promise<LearnerMatchingMetricsResponse[]> {
    const route: ServerRoute = ServerRoute.forAction('LearningMatchingErrorReport', 'aggregated');
    const queryParts = [
      `startDate=${encodeURIComponent(params.startDate.toISOString())}`,
      `endDate=${encodeURIComponent(params.endDate.toISOString())}`,
    ];
    if (params.providerId) {
      queryParts.push(`providerId=${encodeURIComponent(params.providerId)}`);
    }
    return await API.get<LearnerMatchingMetricsResponse[]>(route, queryParts.join('&'));
  }
}
